module.exports = __webpack_public_path__ + "static/media/Black_-_13495_bugbes.bfef1d6d.mp4";